
import { ApiModel } from '@/api/api-model';
import { TipoConsorcio } from '../acuerdo-comercial.consts';

export const API_TYPE_MODULOS_DEFAULT = 'propuesta_comercial';

export class Plantilla extends ApiModel {

  api_type = API_TYPE_MODULOS_DEFAULT;

  nombre_plantilla: string;
  tipo_propuesta: 'plantilla';
  tipo_producto: TipoConsorcio;
  fecha_creacion: Date;
  descuentos_ufs?: {
    tipos: {
      general?: number, // Se aplica a todas las UFs facturables
      cochera?: number
    },
    periodos: number[],
  };
}